import i18next from "i18next";
import { isValidSlug } from "../../util/string";

const validateForm = (values) => {
    const errors = {};

    if (!values.name) {
        errors.name = [i18next.t('%{field} is required', {field: i18next.t('Name')})];
    }

    if (!values.slug) {
        errors.slug = [i18next.t('%{field} is required', {field: i18next.t('Slug')})];
    } else if (!isValidSlug(values.slug)) {
        errors.slug = [i18next.t('Slug must contain only lowercase letters, numbers, and hyphens. It cannot start or end with a hyphen.')];
    }

    return errors;
};

export default validateForm;